var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-pill",class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.status.toUpperCase())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }